import { useEffect, useState } from 'react';

export function ToastHost() {
  const [msg, setMsg] = useState('');
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    let hideTimer: number | undefined;
    const onToast = (e: Event) => {
      const detail = (e as CustomEvent<{ message: string; ms?: number } | string>).detail;
      const message = typeof detail === 'string' ? detail : detail?.message;
      const ms = typeof detail === 'string' ? 2500 : detail?.ms ?? 2500;
      if (!message?.trim()) return;
      if (/^loaded 0\b/i.test(message.trim())) return;
      setMsg(message.trim());
      setVisible(true);
      window.clearTimeout(hideTimer);
      hideTimer = window.setTimeout(() => setVisible(false), ms);
    };
    window.addEventListener('p1s-toast', onToast);
    return () => {
      window.removeEventListener('p1s-toast', onToast);
      window.clearTimeout(hideTimer);
    };
  }, []);

  if (!visible || !msg) return null;
  return (
    <div className="toast" role="status" data-testid="toast">
      {msg}
    </div>
  );
}
